import React from "react";

export default function PageLoader({ label = "Loading your staff services" }) {
  return (
    <div className="pguh-loader" role="status" aria-live="polite">
      <div className="pguh-loader__spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}
